import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
    
      <Header />
    <div>
      <h1>About Us Page</h1>
      <p>This is the content of the about page.</p>
    </div>
    <Footer />
    </div>
  );
};

export default About;
